export default "__VITE_ASSET__QJ_adDgp__"